import {SET_LOADING} from "../Actions/Types/ajaxActionTypes";

const initialState = {
    loading: false,
};

export const ajaxReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.value,
            };
        default:
            return state;
    }
};


